import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type AppRole = "Owner" | "Admin" | "Employee" | "Contractor" | "ReadOnly";

export interface MeResponse {
  isAuthenticated: boolean;
  userId?: string;
  email?: string | null;
  displayName?: string | null;
  tenantId?: string | null;
  role?: AppRole;
  isOwner?: boolean;
  legal?: {
    requiresInitialSignature: boolean;
    requiresLoginConfirmation: boolean;
  };
}

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<MeResponse> => {
      const r = await api().get<MeResponse>("/api/me");
      return r.data;
    },
  });
}
